import React, { CSSProperties, FC } from 'react'
import s from './TextField.module.scss'
import clsx from 'clsx'

type Props = {
    placeholder?: string
    style?: CSSProperties
    className?: string
    onChange: (e: any) => void
    value?: string
}

const TextField: FC<Props> = ({ placeholder, style, className, onChange, value }) => {
    return (
        <textarea
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={clsx(s.text_field, className)}
            style={style}
        />
    )
}

export default TextField